import type React from 'react';
import { useState } from 'react';
import { getPortalLoginNotice, startFromPortal } from '../lib/portal-arrival.ts';
import { PORTAL_URL } from '../lib/env.ts';

/**
 * /login
 *   - 「POTAL を開く」で、引換番号のログインを始める（合言葉を作ってポータルへ行く・lib/portal-flow.ts）
 *   - ポータルから戻ってきたときの番号は、読み込んだ時点で lib/portal-arrival.ts が受け取り、
 *     アドレス欄から消している。うまくいかなかったときだけ、その一言をここに出す
 */

type Status = 'idle' | 'starting' | 'error';

export const LoginPage = (): React.JSX.Element => {
  const notice = getPortalLoginNotice();
  const [status, setStatus] = useState<Status>(notice ? 'error' : 'idle');
  const [errorMessage, setErrorMessage] = useState<string>(notice);

  // 新しいタブで開いたとき（onClick を通らないとき）の行き先は、ポータルのアプリ一覧。
  // 合言葉の無い return_to には番号が出ないため、ここからは portal_login=1 の流れで入る。ふだんは onClick で合言葉を作ってから行く
  const portalReturnUrl = `${PORTAL_URL}/`;

  const start = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    setStatus('starting');
    void startFromPortal().then((result) => {
      if (result === 'redirecting') return;
      setStatus('error');
      setErrorMessage(getPortalLoginNotice());
    });
  };

  return (
    <main style={loginStyle}>
      <h1>🔭 TrendScope</h1>
      {status === 'idle' && (
        <>
          <p>POTAL（SUPPORT LOUNGE PORTAL）からログインしてください。</p>
          <a href={portalReturnUrl} onClick={start} style={portalLinkStyle}>
            POTAL を開く
          </a>
        </>
      )}
      {status === 'starting' && <p>ログイン処理中…</p>}
      {status === 'error' && (
        <>
          <p style={errorStyle}>ログインに失敗しました: {errorMessage}</p>
          <a href={portalReturnUrl} onClick={start} style={portalLinkStyle}>
            POTAL から再度起動する
          </a>
        </>
      )}
    </main>
  );
};

const loginStyle: React.CSSProperties = {
  maxWidth: 480,
  width: '100%',
  margin: '80px auto',
  padding: 24,
  textAlign: 'center',
};

const errorStyle: React.CSSProperties = {
  color: '#c0392b',
};

const portalLinkStyle: React.CSSProperties = {
  display: 'inline-block',
  marginTop: 16,
  padding: '10px 20px',
  background: '#1976d2',
  color: '#fff',
  borderRadius: 4,
  textDecoration: 'none',
};
